/**
 * @fileoverview Present immutable before/after contact-change evidence attached to an activity record. The caller owns the recorded values; this component does not edit current contact identity. `kc-internal-backend/functions/client_contact_history.py` owns history creation and its relationship to current client records.
 */

import React from 'react';

const LABELS = {
  ClientName: 'Client name',
  ClientEmail: 'Primary email',
  ClientPhone: 'Primary phone',
  AdditionalEmails: 'Additional emails',
  AdditionalPhone: 'Additional phones',
};



function displayValue(value) {
  return value === null || value === undefined || value === '' ? 'Not set' : String(value);
}



export default function ContactChangeDetails({ change }) {
  const fields = Object.entries(change?.changes || {}).filter(([field]) => LABELS[field]);
  if (!fields.length) return null;
  return (
    <table className="activity-contact-change-table" aria-label="Contact information changes">
      <thead><tr><th scope="col">Field</th><th scope="col">Before</th><th scope="col">After</th></tr></thead>
      <tbody>
        {fields.map(([field, values]) => (
          <tr key={field}>
            <th scope="row">{LABELS[field]}</th>
            <td>{displayValue(values.before)}</td>
            <td>{displayValue(values.after)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
